"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logging = void 0;
const winston = __importStar(require("winston"));
const winston_browser_console_1 = __importDefault(require("./winston-browser-console"));
const winston_rollbar_1 = __importDefault(require("./winston-rollbar"));
const DEBUG = process.env.DEBUG === 'true' || process.env.NODE_ENV === 'local';
const defaultFormats = [
    winston.format.timestamp(),
    winston.format.json()
];
const transports = [
    new winston_browser_console_1.default({
        level: DEBUG ? 'debug' : 'info',
    }),
    new winston_rollbar_1.default({ level: DEBUG ? 'debug' : 'info' })
];
const loggerFactory = () => winston.createLogger({
    transports,
    format: winston.format.combine(...defaultFormats),
    exitOnError: false
});
exports.logging = loggerFactory();
exports.default = loggerFactory;
//# sourceMappingURL=index.js.map